import styled from "@emotion/styled"
import { Desktop, ImageContainer, Mobile } from "ui"
import { extractProperty } from "utils"

const StyledImageWrapper = styled.div`
  position: relative;
  margin-bottom: 40px;
  padding-left: 20px;
  h4 {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  ${(props) => props.theme.breakpoints.up("md")} {
    margin-bottom: 80px;
    padding-left: 110px;
  }
  ${(props) => props.theme.breakpoints.up("xl")} {
    margin-bottom: 80px;
    padding-left: 220px;
  }
`

function TopBanner({
  data,
  children,
}: {
  data: any
  children: React.ReactNode
}) {
  const desktopImage = extractProperty(data, "desktopImage")
  const mobileImage = extractProperty(data, "mobileImage")
  return (
    <StyledImageWrapper>
      {children}
      <Desktop>
        <ImageContainer
          height={640}
          mobileHeight={420}
          mediumHeight={440}
          sm
          desktopUrl={desktopImage}
          emptyAlt={true}
          fill
        />
      </Desktop>
      <Mobile>
        <ImageContainer
          height={640}
          mobileHeight={420}
          mediumHeight={440}
          desktopUrl={mobileImage}
          sm
          emptyAlt={true}
        />
      </Mobile>
    </StyledImageWrapper>
  )
}

export default TopBanner
